"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCategoryBoxWidth = exports.getCategoryBoxImageHeight = void 0;
var _constants = require("./constants");
var _types = require("./types");
const getCategoryBoxWidth = ({
  size
}) => {
  switch (size) {
    case _types.CategoryBoxSize.MEDIUM:
      return {
        desktop: _constants.CATEGORY_BOX_DESKTOP_MEDIUM_WIDTH,
        mobile: _constants.CATEGORY_BOX_MOBILE_MEDIUM_WIDTH
      };
    case _types.CategoryBoxSize.LARGE:
      return {
        desktop: _constants.CATEGORY_BOX_DESKTOP_LARGE_WIDTH,
        mobile: _constants.CATEGORY_BOX_MOBILE_LARGE_WIDTH
      };
    default:
      return {
        desktop: _constants.CATEGORY_BOX_DESKTOP_WIDTH,
        mobile: _constants.CATEGORY_BOX_MOBILE_WIDTH
      };
  }
};
exports.getCategoryBoxWidth = getCategoryBoxWidth;
const getCategoryBoxImageHeight = ({
  size
}) => {
  switch (size) {
    case _types.CategoryBoxSize.MEDIUM:
      return {
        desktop: _constants.CATEGORY_BOX_IMAGE_DESKTOP_MEDIUM_HEIGHT,
        mobile: _constants.CATEGORY_BOX_IMAGE_MOBILE_MEDIUM_HEIGHT
      };
    case _types.CategoryBoxSize.LARGE:
      return {
        desktop: _constants.CATEGORY_BOX_IMAGE_DESKTOP_LARGE_HEIGHT,
        mobile: _constants.CATEGORY_BOX_IMAGE_MOBILE_LARGE_HEIGHT
      };
    default:
      return {
        desktop: _constants.CATEGORY_BOX_IMAGE_DESKTOP_HEIGHT,
        mobile: _constants.CATEGORY_BOX_IMAGE_MOBILE_HEIGHT
      };
  }
};
exports.getCategoryBoxImageHeight = getCategoryBoxImageHeight;
